<template>
  <div>
    <Welcome
      v-if="rows.length === 0"
      @click="addRow"
    />
    <template v-else>
      <Row
        v-for="(row, i) in rows"
        :key="i"
        :price="itemsByRows[i] && itemsByRows[i].price"
        :number="i + 1"
        :data="row"
        v-bind="row"
        @addSection="addSection(row, $event)"
        @update="updateRow(row, $event)"
        @copy="copyRow(row, i, $event)"
        @remove="removeRow(row, i)"
      />
      <AddRow
        v-if="hasSections"
        @click="addRow"
      />
      <Accessories
        v-if="hasSections"
        :items-by-rows="itemsByRows"
        :role="role"
        :pdf-data="pdfData"
        :wedge-anchors.sync="wedgeAnchors"
        @print="print"
        @download="download"
      />
      <EmailModal :pdf-data="pdfData" />
      <DealerModal :pdf-data="pdfData" />
      <InvoiceModal :inns="inns" :pdf-data="pdfData" />
    </template>
  </div>
</template>

<script>
import logic from './logic';
import Welcome from './components/Welcome.vue'
import Row from './components/Row.vue'
import AddRow from './components/AddRow.vue'
import Accessories from './components/Accessories.vue'
import EmailModal from './components/EmailModal.vue'
import DealerModal from './components/DealerModal.vue'
import InvoiceModal from './components/InvoiceModal.vue'

function normalizeUrl(url) {
  var a = document.createElement('a');
  a.href = url;
  return a.href;
}

function postOpen(url, data, close) {
  var form = document.createElement('form');
  form.method = 'post';
  form.action = normalizeUrl(url);

  var input;
  for (var name in data) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = data[name];
    form.appendChild(input);
  }

  var tmpWindow = window.open('', '_blank');
  tmpWindow.document.body.appendChild(form);
  form.submit();

  if (close) {
    tmpWindow.onload = function() {
      tmpWindow.close();
    };
  }
}

function getOptions(arr, key) {
  return [...new Set(arr.map(item => +item[key]))].sort((a, b) => a - b);
}

function checkCondition(condition, {capacity, depth, length}) {
  return !condition || eval(condition);
}

function getJson(url, cb) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.onload = () => {
      cb(JSON.parse(xhr.responseText));
    };
    xhr.send();
}

export default {
  name: 'App',
  provide () {
    return {
      options: this.options,
    };
  },
  components: {
    Welcome,
    Row,
    AddRow,
    Accessories,
    EmailModal,
    DealerModal,
    InvoiceModal,
  },
  data() {
    return {
      rows: [],
      role: 'user',
      inns: [],
      items: null,
      itemsByRows: [],
      wedgeAnchors: false,
      options: {
        capacity: [300, 500],
        height: [],
        depth: [],
        width: [],
        count: [2, 3, 4, 5, 6, 7],
        type: [
          {text: 'Фанера', value: 'plywood'},
          {text: 'Металл', value: 'metal'},
        ],
      },
    };
  },
  computed: {
    hasSections() {
      return this.rows.some(row => row.sections.length);
    },
    pdfData() {
      return JSON.stringify({
        rows: this.rows,
        itemsByRows: this.itemsByRows,
      });
    },
  },
  watch: {
    rows: {
      deep: true,
      handler: 'calc',
    },
    wedgeAnchors: 'calc',
  },
  mounted() {
    // fetch(process.env.VUE_APP_DATA_URL).then(r => r.json()).then(this.setItems);
    var self = this;
    fetch('/api/calculators/', {
      method: 'post',
      body: JSON.stringify({'action': 'getRole'}),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(promise => promise.json())
    .then((json) => {
      console.log('Response', json);
      self.role = json.data.role;

      if (self.role === 'dealer') {
 				fetch('/api/calculators/', {
 					method: 'post',
 					body: JSON.stringify({'action': 'getInns'}),
 					headers: new Headers({
 						'Content-Type': 'application/json'
 					})
 				})
 				.then(promise => promise.json())
 				.then((json) => {
 					console.log('Response', json);
 					self.inns = json.data.inns;
 				})
 			}
    })

    getJson(process.env.VUE_APP_DATA_URL, (data) => {
      const external_ids = [];
      for (const type in data) {
        for (const item of data[type]) {
          external_ids.push(item.external_id);
        }
      }
      console.log(process.env.VUE_APP_PRODUCTS_URL, external_ids);

      getJson(process.env.VUE_APP_PRODUCTS_URL + '?external_ids=' + external_ids.join(','), (products) => {
        for (const type in data) {
          for (const item of data[type]) {
            const product = products[item.external_id];
            if (product && product.name && product.price) {
              item.name = product.name;
              item.price = product.price;
            }
          }
        }

        this.setItems(data);
      });
    });

    this.addRow();
  },
  methods: {
    setItems(data) {
      this.items = Object.freeze(data);
      this.options.height = getOptions(this.items.rack_kit, 'height');
      this.options.depth = getOptions(this.items.cross_beam, 'depth');
      this.options.width = getOptions(this.items.longitudinal_beam, 'length');
      this.calc();
    },
    calc() {
      if (!this.items)
        return;

      this.itemsByRows = this.rows.map(row => {
        return logic.getRowItems(this.items, row);
      });
    },
    print(download = false) {
      // const query = 'download=' + Number(download) + '&data=' + encodeURIComponent(this.pdfData);
      // window.open(process.env.VUE_APP_PDF_URL + '?' + query, '_blank');
      postOpen(process.env.VUE_APP_PDF_URL, {
        download: Number(download),
        data: this.pdfData,
      }, download);
    },
    download() {
      this.print(true);
    },
    addRow() {
      this.rows.push({
        height: 2000,
        depth: 510,
        sections: [],
      });
    },
    addSection(row, data) {
      row.sections.push({
        isEdit: true,
        width: +data.width,
        count: +data.count,
        parts: 0,
        type: data.type || 'plywood',
        coupler: !!data.coupler,
      });
    },
    updateCapacity(row, capacity) {
      row.capacity = capacity;
    },
    updateRow(row, data) {
      let oldDepth = row.depth;
      row.height = +data.height;
      row.depth = +data.depth;
      if (row.sections[0]) {
        row.sections[0].width = +data.width;
        row.sections[0].count = +data.count;
        if (oldDepth != +data.depth) {
          row.sections.forEach(section => {
            section.isEdit = false;
            if (+data.depth == 760 || +data.depth == 910) {
              section.coupler = true;
            }
          });
        }
      } else {
        this.addSection(row, data);
      }
    },
    copyRow(row, idx, count) {
      for (let i = 0; i < count; i++) {
        const newRow = {
          ...row,
          sections: row.sections.map((section) => ({
            ...section,
          })),
        };
        this.rows.splice(idx + 1, 0, newRow);
      }
    },
    removeRow(row, i) {
      this.rows.splice(i, 1);
    },
  },
}
</script>

<style>
  button {
    padding: 16px 32px;
    font-size: 16px;
    line-height: 18px;
    color: white;
    background: #F58214;
    border: 1px solid transparent;
  }
  button + button {
    margin-left: 16px;
  }
  button.outline {
    color: #F58214;
    background: white;
    border: 1px solid #F58214;
  }
</style>
